import { render, staticRenderFns } from "./trainingextended.vue?vue&type=template&id=d1246192"
import script from "./trainingextended.vue?vue&type=script&lang=js"
export * from "./trainingextended.vue?vue&type=script&lang=js"
import style0 from "./trainingextended.vue?vue&type=style&index=0&id=d1246192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports